<div class="reporting-model-container">
  <div
    class="filter-container"
    style="display:flex; justify-content: space-between"
  >
    <div class="watchlist-select">
      <app-watchlist-dropdown
        *ngIf="userId"
        [userId]="userId"
        (selectWatchlistFunc)="selectWatchlistFunc($event)"
      ></app-watchlist-dropdown>
    </div>
    <app-global-reporting-filters
      [isSearchFilter]="showSearch"
      [(exportColumns)]="exportColumns"
      [exportKey]="exportKey"
      [defaultSearch]="globalSearchVal"
      (isFilterValueChange)="toggleFilter($event)"
      (onGlobalFilterChange)="onSearch($event)"
      (onReloadGrid)="onReloadGrid()"
    ></app-global-reporting-filters>
  </div>
  <div id="columnSorterContainer" *ngIf="columnData.list.length > 0">
    <span class="text">Select columns :</span>
    <app-multi-select-dropdown
      [data]="columnData"
      (callback)="columnDataChange($event, false)"
    >
    </app-multi-select-dropdown>
  </div>
  <div class="grid-container">
    <app-reporting-grid-wrapper
      [page]="'models'"
      [(columns)]="columns"
      [(selectedWatchlistId)]="selectedWatchlist"
      [gridUrl]="gridUrl"
      [showGridFilters]="showGridFilters"
      [sortKey]="sortKey"
      [sortOrder]="'desc'"
      [(globalSearchVal)]="globalSearchVal"
    ></app-reporting-grid-wrapper>
    <nz-modal
      [(nzVisible)]="isModalVisible"
      nzTitle="Model(s)"
      (nzOnCancel)="handleCancel()"
      (nzCancelText)="(null)"
      [nzFooter]="null"
      nzWidth="70%"
      nzWrapClassName="historical-model-modal"
    >
      <ng-container *nzModalContent>
        <div
          class="historical-model-table"
          *ngIf="
            historicalModelData.data &&
            historicalModelData.source_details &&
            historicalModelData.data.length
          "
        >
          <nz-table
            [nzData]="historicalModelData.data"
            [nzFrontPagination]="false"
            [nzShowPagination]="false"
            [nzScroll]="{ x: 'auto', y: '400px' }"
            [nzBordered]="false"
          >
            <thead>
              <tr>
                <th class="col" [nzWidth]="'270px'">Broker</th>
                <th class="col" [nzWidth]="'auto'">Analyst</th>
                <th class="col" [nzWidth]="'150px'">Date</th>
                <th class="col" [nzWidth]="'200px'">Model</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="row"
                *ngFor="
                  let model_revision of historicalModelData.data;
                  index as i
                "
              >
                <td class="col">
                  <a
                    *ngIf="i === 0"
                    title="{{ historicalModelData.source_details.full_name }}"
                    routerLink="/reporting/broker/{{
                      historicalModelData.source_details.short_name
                    }}"
                    routerLinkActive="active"
                    >{{ historicalModelData.source_details.full_name }}</a
                  >
                </td>
                <td class="col">
                  <a
                    title="View Analyst Page"
                    routerLink="/reporting/analyst/{{
                      model_revision.analyst_id
                    }}"
                    routerLinkActive="active"
                    >{{ model_revision.analyst_name }}</a
                  >
                </td>
                <td class="col">
                  <span>{{ model_revision.event_date }}</span>
                </td>
                <td class="col">
                  <div
                    class="link-icon"
                    *ngIf="
                      historicalModelData.source_details.is_model_entitled &&
                      model_revision.file_size &&
                      model_revision.download_applicable
                    "
                    title="Download {{ model_revision.file_name }}"
                    (click)="
                      modelDownloadClick(
                        model_revision.TransactionId,
                        historicalModelData.source_details.short_name
                      )
                    "
                  >
                    <va-icon size="small" name="file-excel"></va-icon>
                    <span>({{ model_revision.file_size }})</span>
                  </div>

                  <div
                    class="disabled-model link-icon"
                    *ngIf="
                      historicalModelData.source_details.is_model_entitled &&
                      model_revision.file_size &&
                      !model_revision.download_applicable
                    "
                    title="A downloadable model is not currently available"
                  >
                    <va-icon size="small" name="file-excel"></va-icon>
                    <span>({{ model_revision.file_size }})</span>
                  </div>

                  <div
                    class="disabled-model link-icon"
                    *ngIf="
                      !historicalModelData.source_details.is_model_entitled &&
                      model_revision.file_size
                    "
                    title="Not entitled"
                  >
                    <va-icon size="small" name="file-excel"></va-icon>
                    <span>({{ model_revision.file_size }})</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </nz-table>
        </div>
      </ng-container>
      <div
        style="padding: 10px 0px"
        *ngIf="
          historicalModelData.data &&
          historicalModelData.source_details &&
          !historicalModelData.data.length
        "
      >
        No Data Found
      </div>
    </nz-modal>
  </div>
</div>
